import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getSearchBroadcast } from '../../services/AudioAnnouncementService';
import type { SearchBroadcastResponse } from '../../types/AudioAnnouncement';

function useSearchBroadcast(
  fleetId: string | null,
  audioAnnouncementId: string | null,
  sendId: string | null,
  searchQuery: string,
): UseQueryResult<SearchBroadcastResponse> {
  const trimmed = searchQuery.trim();
  const enabled = Boolean(fleetId)
    && Boolean(audioAnnouncementId)
    && Boolean(sendId)
    && trimmed.length > 0;

  return useQuery(
    ['broadcast-search', fleetId ?? '', audioAnnouncementId ?? '', sendId ?? '', trimmed],
    (): Promise<SearchBroadcastResponse> => getSearchBroadcast(
      fleetId as string,
      audioAnnouncementId as string,
      sendId as string,
      trimmed,
    ),
    {
      enabled,
      retry: 1,
      staleTime: 0,
    },
  );
}

export default useSearchBroadcast;
